// extracted by mini-css-extract-plugin
module.exports = {"offCampusFields":"OffCampusRequestForm_offCampusFields__1mBBm"};